/* ============================================================
   IDEAS CAFE — Digital partners tabs

   Filters the partner cards by payment method (prepaid / card on
   delivery). The list is one server-rendered <ul>; each card carries
   data-partner-group and is shown when it matches the active tab or
   is marked "both". The opening tab is applied in Liquid, so this
   only handles switching.
   ============================================================ */
(function () {
  'use strict';

  function select(section, key, focus) {
    var tabs = section.querySelectorAll('[data-partner-tab]');
    var track = section.querySelector('[data-partner-panel]');
    if (!track) return;

    tabs.forEach(function (tab) {
      var on = tab.getAttribute('data-partner-tab') === key;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
      if (on && focus) tab.focus();
    });

    track.querySelectorAll('[data-partner-group]').forEach(function (item) {
      var group = item.getAttribute('data-partner-group');
      item.hidden = !(group === 'both' || group === key);
    });

    // Cards shown under both tabs deep-link to the tab now open.
    track.querySelectorAll('[data-partner-link]').forEach(function (link) {
      link.setAttribute(
        'href',
        link.getAttribute('data-partner-link') + '#' + key + '-' + link.getAttribute('data-partner-bank')
      );
    });

    // Back to the first card, and let <ideas-scroller> re-evaluate its
    // arrows now the track's width has changed.
    track.scrollLeft = 0;
    track.dispatchEvent(new Event('scroll'));
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-partner-tab]');
    if (!tab) return;
    select(tab.closest('.ideas-partners'), tab.getAttribute('data-partner-tab'), false);
  });

  // Arrow keys move between tabs, per the WAI-ARIA tabs pattern.
  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest('[data-partner-tab]');
    if (!tab || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;

    var tabs = Array.prototype.slice.call(
      tab.parentElement.querySelectorAll('[data-partner-tab]')
    );
    var step = event.key === 'ArrowRight' ? 1 : -1;
    var next = tabs[(tabs.indexOf(tab) + step + tabs.length) % tabs.length];

    event.preventDefault();
    select(tab.closest('.ideas-partners'), next.getAttribute('data-partner-tab'), true);
  });

  // Theme editor: selecting a hidden partner block switches to its tab,
  // so the merchant can see the card they are editing.
  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest && event.target.closest('[data-partner-group]');
    if (!item || !item.hidden) return;
    select(item.closest('.ideas-partners'), item.getAttribute('data-partner-group'), false);
  });
})();
